import $api from '@/services/api';

export default (Vue) => {
    Vue.api = $api;
    Object.defineProperties(Vue.prototype, {
        $api: {
            get: () => Vue.api,
        },
    });
};
